module.exports = __webpack_public_path__ + "static/futura-book-3d08300b4746311875618c08274a475a.woff";